<div #content id="header-container" class="no-print">
  <div *ngIf="isTeacher && userInfo.hasVideoPresentation==false" class="text-center p-2 teacher-not-video-banner" style="background-color: red;">

    <span class="no-video-alert" style="color: #fff;" [innerHTML]="'video-request-alert' | translate"></span>
  </div>
  <mat-toolbar class="mat-elevation-z1" id="header">
    <!-- <div class="container flex-space-between"> -->
    <div class="header-container flex-space-between">
      <!-- image -->
      <div class="header-first-part">

        <a *ngIf="logoLinkExternal" [href]="logoLinkExternal">
          <ng-container *ngTemplateOutlet="logo"></ng-container>
        </a>

        <a *ngIf="logoLinkInternal" [routerLink]="logoLinkInternal" >
          <ng-container *ngTemplateOutlet="logo"></ng-container>
        </a>
        
        <ng-template #logo>
          <img src="assets/img/logo.svg" class="header-img" />
        </ng-template>

        <div class="header-menu flex-center d-none d-xl-block">
          <a
            *ngIf="!isTeacher"
            [routerLink]="['/search/teacher']"
            class="margin-left-1 link-header-nav"
            routerLinkActive="activated"
            ><i class="fas fa-search"></i> {{ "search-teacher" | translate }}</a
          > |            
          <a
            *ngIf="!isTeacher"
            class="link-header-nav"
            [routerLink]="['/student/group-classes']"
          >
          <i class="fas fa-users"></i> {{ "group-classes" | translate }} 
        </a>
        </div>
        
      </div>

      <div class="header-menu flex-center d-none d-xl-flex">
        <button
          class="wallet-button margin-right-1"
          (click)="goToWallet()"
          *ngIf="user"
        >
          <div class="flex-start">
            <mat-icon svgIcon="wallet"></mat-icon>
            <span>{{ wallet }}</span>
          </div>
        </button>

        <div class="header-custom-languages-desktop">
          <mat-form-field appearance="outline">
            <mat-select
              id="language-desktop-select"
              #language
              [placeholder]="'lang' | translate"
              [(ngModel)]="lang"
              #ctrl="ngModel"
              (ngModelChange)="onChangeLang($event, true)"
            >
              <mat-option [value]="l" *ngFor="let l of langs">
                <div class="flex-center">
                  <img
                    [src]="'assets/img/' + l + '.png'"
                    style="width: 20px; height: 20px; margin-right: 5px"
                  />
                  <div>
                    {{ l | translate }}
                  </div>
                </div>
              </mat-option>
              <mat-select-trigger>
                <div class="flex-center">
                  <div style="margin-right: 5px" class="flex-center">
                    <img
                      [src]="'assets/img/' + lang + '.png'"
                      style="width: 20px; height: 20px"
                    />
                  </div>
                  <div class="flex-center">
                    {{ lang | translate }}
                  </div>
                </div>
              </mat-select-trigger>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="margin-left-1 header-custom-filterable-desktop">
          <app-select-filterable
            [options]="timezones"
            [formControl]="timezoneCtrl"
            (onUserChangeValue)="onUserChangeTimeZone($event)"
          ></app-select-filterable>
        </div>

        <div
          *ngIf="user?.isPremium==true"
          class="d-flex premium-profile margin-left-1"
        >
          <img
            src="../../../assets/img/premium-crown.png"
            alt=""
            class="padding-right-05"
          />
          <p>{{ "premium-profile" | translate }}</p>
        </div>

        <ng-container *ngIf="!ios">
        <button
          class="premium-button-desktop margin-left-1"
          (click)="goToPremium()"
          *ngIf="user?.isPremium==false"
        >
          <div class="flex-start">
            <span><i class="fas fa-crown"></i> {{ "go-premium" | translate }}</span>
          </div>
        </button>
      </ng-container>
      <ng-container *ngIf="ios">
        <button
          class="premium-button-desktop margin-left-1"
          (click)="openWordiix()"
          *ngIf="user?.isPremium==false"
        >
          <div class="flex-start">
            <span><i class="fas fa-crown"></i> {{ "go-premium-web" | translate }}</span>
          </div>
        </button>
      </ng-container>

        <select [(ngModel)]="currency" (change)="currencyChange($event)" class="currency_rate_select">
          <option value="eur">EUR (€)</option>
          <option value="mxn">MXN ($)</option>
          <option value="usd">USD ($)</option>
        </select>
      </div>

      <div class="flex-center" *ngIf="user; else noUserIconTemplate">
        <div class="header-menu-2 margin-right-1 d-none d-xl-flex">
          <a
            [routerLink]="[
              isTeacher ? '/teacher/settings' : '/student/settings/index'
            ]"
            class=""
            routerLinkActive="activated"
          >
            <mat-icon svgIcon="gear"></mat-icon>
            {{ "settings" | translate }}
          </a>
          
        </div>
        
        <div
          *ngIf="!user || !user.profile_photo_path; else imageUserTemplate"
          [matMenuTriggerFor]="menu"
          class="d-flex"
        >
          <mat-icon svgIcon="user" class="user-icon"> </mat-icon>
          <mat-icon
            svgIcon="arrow-down"
            color="black"
            class="light-gray"
          ></mat-icon>
        </div>
        <ng-template #imageUserTemplate>
          <div [matMenuTriggerFor]="menu" class="d-flex">
            <img
              class="img-user"
              [src]="user.profile_photo_path"
              appErrorImage
            />
            <mat-icon
              svgIcon="arrow-down"
              color="black"
              class="light-gray"
            ></mat-icon>
          </div>
        </ng-template>

        <!-- MENU -->
        <mat-menu #menu="matMenu" class="sub-menu mobile-menu-2">
          <mat-select
            style="height: 48px; border: none"
            #language
            class="form-control d-lg-block d-xl-none"
            [placeholder]="'gender' | translate"
            [(ngModel)]="lang"
            #ctrl="ngModel"
            (ngModelChange)="onChangeLang($event, true)"
          >
            <mat-option [value]="l" *ngFor="let l of langs">
              <div class="flex-center">
                <img
                  [src]="'assets/img/' + l + '.png'"
                  style="width: 20px; height: 20px; margin-right: 5px"
                />
                <div>
                  {{ l | translate }}
                </div>
              </div>
            </mat-option>
            <mat-select-trigger>
              <div class="flex-center">
                <div style="margin-right: 5px" class="flex-center">
                  <img
                    [src]="'assets/img/' + lang + '.png'"
                    style="width: 20px; height: 20px"
                  />
                </div>
                <div class="flex-center">
                  {{ lang | translate }}
                </div>
              </div>
            </mat-select-trigger>
          </mat-select>
          <mat-divider class="d-lg-block d-xl-none"></mat-divider>
          <div
            class="header-custom-filterable-mobile d-lg-block d-xl-none"
            style="padding-top: 8px"
          >
            <app-select-filterable
              [type]="2"
              [options]="timezones"
              [formControl]="timezoneCtrl"
              (onUserChangeValue)="onUserChangeTimeZone($event)"
              style="height: 48px; border: none"
            >
            </app-select-filterable>
          </div>
          <mat-divider class="d-lg-block d-xl-none"></mat-divider>
          <button
            mat-menu-item
            *ngIf="!isTeacher"
            class="d-lg-block d-xl-none"
            [routerLink]="['/search/teacher']"
          >
          <i class="fas fa-search"></i> {{ "search-teacher" | translate }}
          </button>

          <mat-divider class="d-lg-block d-xl-none"></mat-divider>
          <button
            mat-menu-item
            *ngIf="!isTeacher"
            class="d-lg-block d-xl-none"
            [routerLink]="['/student/group-classes']"
          >
          <i class="fas fa-users"></i> Clases grupales
          </button>

          <mat-divider
            *ngIf="!isTeacher"
            class="d-lg-block d-xl-none"
          ></mat-divider>
          <div class="d-lg-block d-xl-none">
            <button mat-menu-item (click)="goToWallet()">
              <div class="flex-start">
                <mat-icon svgIcon="wallet"></mat-icon>
                <span>{{ wallet }}</span>
              </div>
            </button>
            <mat-divider class="d-lg-block d-xl-none"></mat-divider>
          </div>
          <div *ngIf="checkShowGoPremium">
            <ng-container *ngIf="!ios">
              <button
                class="d-lg-block d-xl-none"
                mat-menu-item
                (click)="goToPremium()"
              >
                <div class="flex-start">
                  <mat-icon svgIcon="premium"></mat-icon>
                  <span>{{ "go-premium" | translate }}</span>
                </div>
              </button>
            </ng-container>
            <ng-container *ngIf="ios">
              <button
                class="d-lg-block d-xl-none"
                mat-menu-item
                (click)="openWordiix()"
              >
                <div class="flex-start">
                  <mat-icon svgIcon="premium"></mat-icon>
                  <span>{{ "go-premium-web" | translate }}</span>
                </div>
              </button>
            </ng-container>
            <mat-divider class="d-lg-block d-xl-none"></mat-divider>
          </div>
          <button mat-menu-item (click)="goToProfile()">
            <mat-icon svgIcon="user-solid"></mat-icon>
            {{ "show-profile" | translate }}
          </button>
          <mat-divider *ngIf="user" class="d-lg-block d-xl-none"></mat-divider>
          <button
            mat-menu-item
            *ngIf="user"
            class="d-lg-block d-xl-none"
            [routerLink]="[
              isTeacher ? '/teacher/settings' : '/student/settings/index'
            ]"
          >
            <mat-icon svgIcon="gear"></mat-icon>
            {{ "settings" | translate }}
          </button>
          <mat-divider></mat-divider>
          <button mat-menu-item id="logout-btn" (click)="logout()">
            <mat-icon svgIcon="logout"></mat-icon>
            {{ "logout" | translate }}
          </button>
        </mat-menu>
      </div>

      
      

      <ng-template #noUserIconTemplate>
        <div class="flex-center">
          <div [matMenuTriggerFor]="menu">
            <mat-icon svgIcon="user" class="user-icon"> </mat-icon>
            <mat-icon
              svgIcon="arrow-down"
              color="black"
              class="light-gray"
            ></mat-icon>
          </div>

          <!-- MENU 2 -->
          <mat-menu #menu="matMenu">
            <mat-select
              style="height: 48px; border: none; position:absolute"
              #language
              class="form-control d-lg-block d-xl-none"
              [placeholder]="'gender' | translate"
              [(ngModel)]="lang"
              #ctrl="ngModel"
              (ngModelChange)="onChangeLang($event, true)"
            >
              <mat-option [value]="l" *ngFor="let l of langs">
                <div class="flex-center">
                  <img
                    [src]="'assets/img/' + l + '.png'"
                    style="width: 20px; height: 20px; margin-right: 5px"
                  />
                  <div>
                    {{ l | translate }}
                  </div>
                </div>
              </mat-option>
              <mat-select-trigger>
                <div class="flex-center">
                  <div style="margin-right: 5px" class="flex-center">
                    <img
                      [src]="'assets/img/' + lang + '.png'"
                      style="width: 20px; height: 20px"
                    />
                  </div>
                  <div class="flex-center">
                    {{ lang | translate }}
                  </div>
                </div>
              </mat-select-trigger>
            </mat-select>
            <mat-divider class="d-lg-block d-xl-none"></mat-divider>
            <div
              class="header-custom-filterable-mobile d-lg-block d-xl-none"
              style="padding-top: 8px"
            >
              <app-select-filterable
                (onUserChangeValue)="onUserChangeTimeZone($event)"
                [type]="2"
                [options]="timezones"
                [formControl]="timezoneCtrl"
                style="height: 48px; border: none"
              ></app-select-filterable>
            </div>
            <mat-divider class="d-lg-block d-xl-none"></mat-divider>
            <button
              mat-menu-item
              *ngIf="!isTeacher"
              class="d-lg-block d-xl-none"
              [routerLink]="['/search/teacher']"
            >
              {{ "search-teacher" | translate }}
            </button>
            <mat-divider class="d-xl-none"></mat-divider>
            

              <mat-select style="padding: 15px 10px;" [(ngModel)]="currency" (selectionChange)="currencyChange($event)" >
                <mat-option value="eur">EUR (€)</mat-option>
                <mat-option value="mxn">MXN ($)</mat-option>
                <mat-option value="usd">USD ($)</mat-option>
              </mat-select>
            



            <mat-divider class="d-xl-none"></mat-divider>
            <button mat-menu-item id="login-btn" [routerLink]="['/auth/login']">
              {{ "login" | translate }}
            </button>
          </mat-menu>
        </div>
      </ng-template>
    </div>
  </mat-toolbar>

  <div [ngSwitch]="subheader">
    <!-- Teacher -->
    <mat-toolbar
      *ngSwitchCase="'teacher'"
      class="subheader"
      style="overflow-x: auto"
    >
      <div class="header-container flex-space-between">
        <!-- Group 1 -->
        <div>
          <mat-icon
            *ngIf="sideNav && isMobile"
            svgIcon="menu"
            class="margin-right-1"
            (click)="sideNav.toggle()"
          >
          </mat-icon>

          <a
            [routerLink]="['/teacher/dashboard']"
            class="margin-right-1"
            routerLinkActive="activated"
            >{{ "profile" | translate }}</a
          >

          <a
            [routerLink]="['/teacher/classes']"
            class="margin-right-1"
            routerLinkActive="activated"
            >{{ "my-classes" | translate }}</a
          >

          <a
            [routerLink]="['/messages']"
            class="margin-right-1"
            routerLinkActive="activated"
            >{{ "messages" | translate }}<span class="badge badge-danger" *ngIf="noReadMessages > 0"> {{ noReadMessages }}</span></a
          >

          <a
            [routerLink]="['/teacher/calendar']"
            class="margin-right-1"
            routerLinkActive="activated"
            >{{ "calendar" | translate }}</a
          >

          <a
            [routerLink]="['/teacher/statistics']"
            class="margin-right-1"
            routerLinkActive="activated"
            >{{ "my-statistics" | translate }}</a
          >
        </div>

        <!-- Group 2 -->
        <div></div>
      </div>
    </mat-toolbar>

    <!-- student -->
    <mat-toolbar
      *ngSwitchCase="'student'"
      class="subheader"
      style="overflow-x: auto"
    >
      <div class="header-container flex-space-between">
        <!-- Group 1 -->
        <div>
          <mat-icon
            *ngIf="sideNav && isMobile"
            svgIcon="menu"
            class="margin-right-1"
            (click)="sideNav.toggle()"
          >
          </mat-icon>

          <a
            [routerLink]="['/student/dashboard']"
            class="margin-right-1"
            routerLinkActive="activated"
            >{{ "profile" | translate }}</a
          >

          <a
            [routerLink]="['/student/settings/classes']"
            class="margin-right-1"
            routerLinkActive="activated"
            >{{ "my-classes" | translate }}</a
          >

          <a
            [routerLink]="['/student/settings/my-teachers']"
            class="margin-right-1"
            routerLinkActive="activated"
            >{{ "my-teachers" | translate }}</a
          >

          <a
            [routerLink]="['/student/settings/calendar']"
            class="margin-right-1"
            routerLinkActive="activated"
            >{{ "calendar" | translate }}</a
          >

          <a
            [routerLink]="['/messages']"
            class="margin-right-1"
            routerLinkActive="activated"
            >{{ "messages" | translate }} <span class="badge badge-danger"  *ngIf="noReadMessages > 0"> {{ noReadMessages }}</span></a
          >
        </div>

        <!-- Group 2 -->
        <div></div>
      </div>
    </mat-toolbar>
  </div>
</div>

